<template>
  <TopBar title="How many years of work experience have you completed since you finished your studies?" subtitle="Please click and drag the slider to indicate how many years of work experience you have." :step="step"/>
  <div class="step">
    <div class="slider-container">
      <button class="btn-sign" @click="subtract"><img src="./../assets/images/minus.svg"></button>
      <div class="slider">
        <Slider v-model="workExperience" :min="0" :max="10" :options="{ connect: 'lower' }" :format="format" />
        <div class="numbers">
          <div class="number">0</div>
          <div class="number">10+</div>
        </div>
      </div>
      <button class="btn-sign" @click="plus"><img src="./../assets/images/plus.svg"></button>
    </div>
  </div>
  <BottomBar :step="step" />
</template>
<script>
import TopBar from '@/components/TopBar'
import BottomBar from '@/components/BottomBar'

import Slider from '@vueform/slider'

export default {
  props: {
    step: {
      required: true
    }
  },
  components: {
    TopBar,
    BottomBar,
    Slider
  },
  computed: {
    workExperience: {
      get () { return this.$store.state.formData.workExperience },
      set (value) { this.$store.commit('setFormData', { key: 'workExperience', value }) }
    }
  },
  methods: {
    format: function (value) {
      if (Math.round(value) === 0) {
        return Math.round(value)
      }
      return `${Math.round(value)} Years`
    },
    subtract () {
      this.workExperience = this.workExperience - 1
    },
    plus () {
      this.workExperience = this.workExperience + 1
    }
  }
}
</script>
<style lang="scss">
@import "./../assets/scss/variables";
@import "./../assets/scss/mixins";

#ec-steps.step-7 {
  .step {
    max-width: 50.5rem;
    margin: 0 auto;
    padding-bottom: 6rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include respond-above(lg) {
      padding-bottom: 0;
    }
  }
}

.slider-container {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;

  button {
    &.btn-sign {
      color: $red;
      font-size: 3rem;
      align-items: flex-start;
      padding-top: 35px !important;
    }
  }

  .slider {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 35px 1rem;
    font-family: $font-family-sans;
  }

  .numbers {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    font-size: 16px;
  }

  .slider-target {
    flex-grow: 1;
    margin-bottom: 0.5rem;
  }
}
</style>
